import { useWorkspace } from "@/hooks/workspace";
import { useState } from "react";
import { ExportPromoProductsUseCase } from "@/core/usecases/promotion/ExportPromoProducts.useCase";
import { ExportPromoProductsRepository } from "@/infrastructure/repositories/export/export.promoProducts.repository";

export function usePromoProductExport() {
  const { settings: workspaceSettings } = useWorkspace();
  const [isPromoProductExporting, setIsPromoProductExporting] = useState(false);

  const handlePromoProductExport = async (promoEventId: number, search: string | null) => {
    const formats = {
      date: workspaceSettings?.displayDateFormat,
      number: workspaceSettings?.displayNumberFormat,
    };

    const params = {
      promo_event_id: promoEventId,
      search: search ?? undefined,
    };

    setIsPromoProductExporting(true);
    const exportPromoProductsRepository = new ExportPromoProductsRepository();
    const exportPromoProductsUseCase = new ExportPromoProductsUseCase(exportPromoProductsRepository);
    return await exportPromoProductsUseCase.execute({ formats, params });
  };

  return { handlePromoProductExport, isPromoProductExporting, setIsPromoProductExporting };
}
